import { CaretLineLeftIcon } from "src/components/icons/CaretLineLeftIcon";

import { withShowToggle } from "../hoc/withShowToggle";

import { Button } from "./button";
import { ButtonProps } from "./types";

import "./buttons.scss";

/**
 * A secondary button used to toggle a details side-panel open.
 * Typically placed in collapsible sections (e.g. port view,
 * topology diagram). Renders a "Details" label with a caret icon
 * and supports conditional visibility via the `show` prop
 * provided by `withShowToggle`.
 */
export const DetailsButton = withShowToggle((props: ButtonProps) => {
  return (
    <Button
      kind="secondary"
      className="details-btn"
      size="md"
      name="detailsActionBtn"
      data-qa="details-button"
      {...props}
    >
      Details
      <CaretLineLeftIcon />
    </Button>
  );
});
